module.exports = __webpack_public_path__ + "static/media/SOLID-SLATE-LOGO-03.99042ae6.svg";